
/**
 * @ngdoc directive
 * @name keyfigures
 *
 * @description
 * KeyFigures
 */
module.directive('keyfigures', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            content: '=',
            textcolor: '@',
            backgroundcolor: '@'
        },
        template:
                '<div class="aqua-keyfigures" ng-style="{color:textcolor, backgroundColor:backgroundcolor}">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-keyfigures--title">{{label}}</span></h2>' +
                '    <div class="grid grid-center">' +
                '      <ul class="aqua-keyfigures--items">' +
                '        <li ng-repeat="figure in content"><span class="aqua-keyfigures--figure">{{figure.number | shorten}}</span><span class="aqua-keyfigures--text">{{figure.legend}}</span></li>' +
                '      </ul>' +
                '    </div>' +
                '  </div>' +
                '</div>'
    };
});

module.filter('shorten', function() {
  return function(input) {
    if (input && input > 1000) {
      return (input / 1000).toFixed(0) + "K";
    }
    return input;
  };
});

